import { Component, Input, OnInit, inject } from "@angular/core";
import { VisitBookingReasonStore } from "@app/services/store/visit-booking-reason-store";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogContent
} from "@angular/material/dialog";
import { BookingReasonStore } from "@app/services/store/booking-reason-store";
import { UntypedFormBuilder } from "@angular/forms";
import { TicketStore } from "@app/services/store/ticket-store";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { select, Store } from "@ngrx/store";
import { Router } from "@angular/router";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { VisitBookingReason } from "@app/models/rest/visit-booking-reason";
import { VisitAuditViewerComponent } from "@app/view/shared/audits/visit-audit-viewer/visit-audit-viewer.component";
import { selectorAuth } from "@app/core";
import { CdkDrag } from "@angular/cdk/drag-drop";
import { DialogHeaderComponent } from "@app/view/shared/dialog-header/dialog-header.component";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { GridComponent } from "../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "app-booking-history",
  templateUrl: "./booking-history.component.html",
  styleUrls: ["./booking-history.component.css"],
  imports: [
    CdkDrag,
    CdkScrollable,
    MatDialogContent,
    GridComponent,
    MatPaginator,
    DialogHeaderComponent
  ]
})
export class BookingHistoryComponent
  extends BaseDataTablePageDirective<VisitBookingReason>
  implements OnInit
{
  visitBookingReasonStore: VisitBookingReasonStore;
  dialogRef = inject<MatDialogRef<BookingHistoryComponent>>(MatDialogRef);
  bookingReasonStore = inject(BookingReasonStore);
  ticketStore = inject(TicketStore);
  fb = inject(UntypedFormBuilder);
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;
  data = inject(MAT_DIALOG_DATA);

  @Input()
  public allowAudit: boolean = false;
  public columns: object[] = [
    {
      field: "bookingDate",
      text: "Date",
      width: 110,
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      editor: true
    },
    {
      field: "reason.description",
      text: "Selected Reason",
      flex: 1,
      editor: false
    },
    {
      field: "note",
      text: "Note",
      width: 400,
      editor: false,
      type: "template",
      autoHeight: true,
      template: ({ record }) => {
        return `${record.get("note") ? record.get("note") : ""}`;
      }
    },
    {
      field: "user.displayName",
      text: "User",
      flex: 1,
      editor: false
    },
    {
      field: "newStartDate",
      text: "New Start",
      flex: 1,
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      editor: false
    },
    {
      field: "newEndDate",
      text: "New End",
      flex: 1,
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      editor: false
    },
    {
      field: "originalStartDate",
      text: "Previous Start",
      flex: 1,
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      editor: false
    },
    {
      field: "originalEndDate",
      text: "Previous End",
      flex: 1,
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      editor: false
    }
    // {
    //   field: 'lastRunDate',
    //   text: 'Last Run Date',
    //   flex: 1,
    //   format: 'YYYY-MM-DD',
    //   type: 'date',
    //   editor: true
    // }
  ];

  constructor() {
    const visitBookingReasonStore = inject(VisitBookingReasonStore);
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      visitBookingReasonStore,
      store,
      dialog,
      "VisitBookingReason",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );
    this.visitBookingReasonStore = visitBookingReasonStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;

    this.store.pipe(select(selectorAuth)).subscribe((auth) => {
      this.allowAudit = !!auth && auth.allowAudit;
    });
  }

  // ngOnInit() {
  //   let ticketId = this.data.ticketId;
  //   this.ticketStore.loadSingle(ticketId, null, 'detail').then(ticket => {
  //     this.visitBookingReasonStore.advancedSearchObservable(0, 100, 'detail', '&sort=bookingDate,desc', null, [{
  //       key: 'visit.id',
  //       operation: 'Equals',
  //       value: ticket.visit.id
  //     }]).subscribe(value => {
  //       console.log('found values');
  //     });
  //   });
  //
  // }
  ngOnInit() {
    super.ngOnInit();
    this.gridStore.parentField = "visit.id";
    this.gridStore.parentId = this.data.visit?.id;
    this.gridStore.parentResource = this.data.visit;
    this.gridStore.parentRel = "visit";
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  openVisitAudit() {
    this.dialog.open(VisitAuditViewerComponent, {
      width: "calc(100vw - 100px)",
      data: {
        visitId: this.data.visit.id
      }
    });
  }
}
